import styles from '@styles/scss/list/_popupModal.module.scss';
import buttonStyles from '@styles/scss/buttons/_buttons.module.scss';

import Image from 'next/image';
import { Performer } from 'lib/types/item/performer';
import { useRef } from 'react';
import { Popup } from 'lib/types/item/popup';
import { useTrackingUrl } from 'lib/hooks/useTrackingUrl';

export default function PopupModal({
  popupText,
  onClose,
  gender,
  currentLang,
  performer
}: {
  popupText: Popup;
  onClose: () => void;
  gender: string;
  currentLang: string;
  performer?: Performer;
}): JSX.Element {
  const modalRef = useRef<HTMLDivElement>(null);
  
  const loginTracking = useTrackingUrl({
    baseUrl: 'https://rabbits.webcam/',
    tag: 'login',
    passthru1: gender,
    passthru2: currentLang
  });
  
  const signupTracking = useTrackingUrl({
    baseUrl: 'https://rabbits.webcam/',
    tag: 'signup',
    passthru1: gender,
    passthru2: currentLang
  });
  let src: string;
  if (performer && performer.gallery_image) {
    src = performer.gallery_image;
  } else {
    src = `https://assets.camrabbit.sex/popup/${gender}-popup.png`;
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose();
    }
  };

  if (popupText.text_1?.includes('$Model-Name$') && performer?.username) {
      popupText.text_1 = popupText.text_1.replace('$Model-Name$', performer.username);
  }


  if (popupText.text_2.includes('?')) {
      const [before, after] = popupText.text_2.split('?');
      popupText.text_2 = `${before}? <a href="${loginTracking.trackingUrl}">${after.trim()}</a>`;
  }
  
  return (
    <div className={styles.overlay} onClick={handleOverlayClick} role="presentation">
      <div className={styles.popupContainer} ref={modalRef}>
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="45" height="25" viewBox="0 0 65 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="0.5" width="63" height="43" stroke="#C9BA7C"/>
            <path d="M40.52 31.9H38.7C38.5133 31.9 38.3667 31.8467 38.26 31.74C38.1533 31.62 38.0667 31.5067 38 31.4L31.96 22.58C31.9067 22.82 31.8067 23.0533 31.66 23.28L25.9 31.4C25.8067 31.52 25.7067 31.6333 25.6 31.74C25.5067 31.8467 25.38 31.9 25.22 31.9H23.5L30.74 21.72L23.78 12H25.6C25.7867 12 25.9267 12.04 26.02 12.12C26.1133 12.2 26.1933 12.2933 26.26 12.4L32.1 20.82C32.1267 20.7133 32.1667 20.6 32.22 20.48C32.2867 20.36 32.3533 20.24 32.42 20.12L37.88 12.42C37.96 12.3 38.0467 12.2 38.14 12.12C38.2333 12.04 38.3533 12 38.5 12H40.24L33.3 21.6L40.52 31.9Z" fill="#C9BA7C"/>
            </svg>

        </button>
        <div className={styles.textSection}>
          <span className={styles.largeText}>{popupText.text_1}</span>
          <a
                ref={signupTracking.linkRef}
                className={`${buttonStyles.primaryButton} ${styles.button}`}
                href={signupTracking.trackingUrl}
                data-event-category='Outbound Click'
                data-event-action='CTA Modal 1min'
                data-event-label='Button-CTA'>
                <span>{popupText.cta_text.toUpperCase()}</span>
            </a>
            <span
              className={`${styles.smallText} ${styles.link}`}
              dangerouslySetInnerHTML={{ __html: popupText.text_2 }}
            />
            <span className={styles.largeText}>{popupText.text_3}</span>
            <span className={styles.smallText}>{popupText.text_4}</span>
        </div>
        <div className={styles.imageSection}>
          <Image loader={() => src} src={src} alt='popup' className={styles.image} height={345} width={460}/>
        </div>
      </div>
    </div>
  );
}
